import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { AccountService } from "../services/account-service";
import { NotifyService } from "../services/notify-service";
import { CommentService } from "../services/comment-service";
import { AclService } from "../services/acl-service";

import * as angular from "angular";

export interface ICommentsScope extends ng.IScope {
    entityId: string;
}

export interface ICommentScope extends ng.IScope {
    comment: Models.IComment;
}

export function RLComments(): ng.IDirective {
    return {
        restrict: 'EA',
        template: require("/assets/app/templates/comments/comments.html"),
        scope: {
            entityId: "="
        },
        controller: CommentsController,
        bindToController: true,
        controllerAs: 'cmVM',
        link: (scope: ICommentsScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any) => {
        }
    }
}

export class CommentsController {
    static $inject = ["$window", "$scope", "commentService", "accountService", "notifyService", "aclService", "sharedCommentService"];

    entityId: string;
    comments: Models.IComment[];
    currentUser: Models.IAccountManageState;
    newComment: Models.IComment;

    canRead: boolean = false;
    canEdit: boolean = false;
    canCreate: boolean = false;
    canDelete: boolean = false;
    canAdmin: boolean = false;

    constructor(
        private $window: ng.IWindowService,
        private $scope: ng.IScope,
        private commentService: CommentService,
        private accountService: AccountService,
        private notifyService: NotifyService,
        private aclService: AclService) {

        $scope.$on(Consts.Events.RefreshComments,
            () => {
                commentService.getComments(this.entityId)
                    .then((res) => {
                        this.comments = res.comments;
                    });
            });

        $scope.$watch(() => this.entityId, (newValue, oldValue) => {
            if (newValue) {
                commentService.getComments(newValue)
                    .then((res) => {
                        this.comments = res.comments;
                    });

                //Parse the chartype of the entity
                var charTypeID = Utils.IdBuilder.splitEntityID(this.entityId).charTypeID;

                this.aclService.loadActivityAcls()
                    .then((acls) => {
                        var targetACL;

                        switch (charTypeID) {
                            case 2:
                                {
                                    targetACL = Consts.Acl.Activities._Site._Mod2.Comments;
                                    break;
                                }
                            case 16:
                                {
                                    targetACL = Consts.Acl.Activities._Site._Mod16.Comments;
                                    break;
                                }
                            case 1:
                                {
                                    targetACL = Consts.Acl.Activities._Site._Mod1.Comments;
                                    break;
                                }
                            case 4:
                                {
                                    targetACL = Consts.Acl.Activities._Site._Mod4.Comments;
                                    break;
                                }
                            case 17:
                                {
                                    targetACL = Consts.Acl.Activities._Site._Mod17.Comments;
                                    break;
                                }
                            case 15:
                                {
                                    targetACL = Consts.Acl.Activities._Site._Mod15.Comments;
                                    break;
                                }
                            case 7:
                                {
                                    targetACL = Consts.Acl.Activities._Site._Mod7.Comments;
                                    break;
                                }
                        }
                        this.canRead = Utils.AclUtil.hasReadAccess(acls, targetACL);
                        this.canEdit = Utils.AclUtil.hasWriteAccess(acls, targetACL);
                        this.canCreate = Utils.AclUtil.hasCreateAccess(acls, targetACL);
                        this.canDelete = Utils.AclUtil.hasDeleteAccess(acls, targetACL);
                        this.canAdmin = Utils.AclUtil.hasAdminAccess(acls, targetACL);
                    });
            }
        });

        this.Init();
    }

    Init() {
        this.notifyService.startProgress();
        this.accountService.getAccountManageState()
            .then((res) => {
                this.currentUser = res;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    DeleteComment(comment: Models.IComment) {
        if (this.$window.confirm("Are you sure you want to delete this comment?")) {
            this.notifyService.startProgress();
            this.commentService.deleteComment(comment)
                .then(() => {
                    this.commentService.getComments(this.entityId)
                        .then((res) => {
                            this.comments = res.comments;
                        });
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    AddComment() {
        this.newComment = {
            userID: this.currentUser.userID,
            userName: this.currentUser.userDisplayName,
            entityId: this.entityId,
            profileAvatar: this.currentUser.profileAvatar,
            text: '',
            editMode: true
        };

        var watcher = this.$scope.$watch(() => this.newComment, (newValue, oldValue) => {
            if (newValue) {
                // created a new comment
                if (newValue.id && !oldValue.id) {
                    this.comments.splice(0, 0, newValue);
                    this.newComment = null;
                    // cancel this watcher
                    watcher();
                }
                // cancelled
                else if (!newValue.editMode) {
                    this.newComment = null;
                    // cancel this watcher
                    watcher();
                }
            }
        }, true);
    }
}

RLCommentThread.$inject = ['RecursionHelper'];
export function RLCommentThread(recursionHelper: RecursionHelper): ng.IDirective {
    return {
        restrict: 'EA',
        template: require("/assets/app/templates/comments/commentThread.html"),
        scope: {
            rootComment: '=',
            entityId: "=",
            canCreate: "=",
            canEdit: "=",
            canDelete: "=",
            canAdmin: "="
        },
        compile: (element: ng.IAugmentedJQuery) => {
            return recursionHelper.compile(element);
        }
    }
}

export function RLComment(): ng.IDirective {
    return {
        restrict: 'EA',
        template: require("/assets/app/templates/comments/comment.html"),
        require: '^commentThread',
        controller: CommentController,
        bindToController: true,
        controllerAs: 'commVM',
        scope: {
            comment: "=",
            entityId: "=",
            canCreate: "=",
            canEdit: "=",
            canDelete: "=",
            canAdmin: "="
        }
    }
}

export class CommentController {
    static $inject = ["$scope", "$rootScope", "$window", "commentService", "notifyService", "sharedCommentService"];
    oldComment: Models.IComment;
    comment: Models.IComment;
    currentUser: Models.IAccountManageState;
    entityId: string;
    canCreate: boolean;
    canEdit: boolean;
    canDelete: boolean;
    canAdmin: boolean;

    constructor(
        private $scope: ng.IScope,
        private $rootScope: ng.IRootScopeService,
        private $window: ng.IWindowService,
        private commentService: CommentService,
        private notifyService: NotifyService,
        private sharedCommentService: SharedCommentService) {

        $scope.$watch(() => this.comment, (newValue, oldValue) => {
            // store old comment to restore when cancelling
            if (newValue && oldValue) {
                if (newValue.editMode && !oldValue.editMode) {
                    this.oldComment = oldValue;
                }
            }
        }, true);

        sharedCommentService.getCurrentUser().then((user) => {
            this.currentUser = user;
        });
    }

    DeleteComment(comment: Models.IComment) {
        if (this.$window.confirm("Are you sure you want to delete this comment?")) {
            this.notifyService.startProgress();
            this.commentService.deleteComment(comment)
                .then(() => {
                    //Update the parent of this comment
                    var parentScope: any = this.$scope.$parent.$parent.$parent;
                    if (parentScope.rootComment) {
                        var parentChildren: Models.IComment[] = parentScope.rootComment.children;

                        if (parentChildren && parentChildren.length > 0) {
                            var childIndex = parentChildren.findIndex(c => c.id == comment.id);
                            parentChildren.splice(childIndex, 1);
                        }
                    }

                    if (!this.comment.children || this.comment.children.length === 0) {
                        this.comment = null;
                    } else {
                        this.comment.text = undefined;
                    }
                })
                .finally(() => {
                    this.$rootScope.$broadcast(Consts.Events.RefreshComments);

                    this.notifyService.endProgress();
                });
        }
    }

    Reply(comment: Models.IComment) {
        comment.children = comment.children || [];
        comment.children.splice(0, 0, {
            userID: this.currentUser.userID,
            userName: this.currentUser.userDisplayName,
            profileAvatar: this.currentUser.profileAvatar,
            text: '',
            editMode: true,
            entityId: this.entityId,
            parentId: comment.id
        });
    }

    CancelEdit(comment: Models.IComment) {
        // if this was an existing comment reset it
        if (comment.id) {
            this.comment = this.oldComment;
            this.oldComment = null;
        }
        // else this was a new comment
        else {
            if (comment.parentId) {
                // typically I hate touching $parent but this is actually the first use-case i've seen where it seems okay
                // parents: comment-thread, ng-repeat, comment
                var parentScope: any = this.$scope.$parent.$parent.$parent;
                var comments = parentScope.rootComment.children;
                var idx = -1;
                for (var i = 0; i < comments.length; i++) {
                    if (comments[i] == comment) {
                        idx = i;
                    }
                }

                if (idx > -1) {
                    comments.splice(idx, 1);
                }
            }

            this.comment = null;
        }
    }

    SaveComment() {
        this.notifyService.startProgress();
        // creating
        if (!this.comment.id) {
            this.commentService.createComment(this.comment)
                .then((res) => {
                    this.comment.id = res.id;
                    this.comment.userID = this.currentUser.userID;
                    this.comment.editMode = false;
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
        // updating
        else {
            this.commentService.updateComment(this.comment)
                .then(() => {
                    this.comment.editMode = false;
                    this.notifyService.endProgress();
                });
        }
    }
}

export class SharedCommentService {
    static $inject = ["accountService", "$q"];
    currentUser: Models.IAccountManageState;
    loadingUser: boolean;
    deferred = this.$q.defer<Models.IAccountManageState>();

    constructor(private accountService: AccountService, private $q: ng.IQService) {

    }

    getCurrentUser() {
        if (!this.currentUser && !this.loadingUser) {
            this.loadingUser = true;
            this.accountService.getAccountManageState()
                .then((res) => {
                    this.currentUser = res;
                    this.deferred.resolve(res);
                });
        } else if (this.currentUser) {
            this.deferred.resolve(this.currentUser);
        }

        return this.deferred.promise;
    }
}

// http://stackoverflow.com/questions/14430655/recursion-in-angular-directives
export class RecursionHelper {
    static $inject = ["$compile"];
    constructor(private $compile: ng.ICompileService) { }

    compile(element: ng.IAugmentedJQuery, link: ng.IDirectiveLinkFn = null): ng.IDirectivePrePost {
        // jesus christ wtf
        var compile = this.$compile;

        var linkFunc: ng.IDirectivePrePost;
        // Normalize the link parameter
        if (angular.isFunction(link)) {
            linkFunc = { post: link };
        }

        // Break the recursion loop by removing the contents
        var contents = element.contents().remove();
        var compiledContents;
        return {
            pre: () => {
                (linkFunc && linkFunc.pre) ? linkFunc.pre : null;
            },
            /**
             * Compiles and re-adds the contents
             */
            post: function (scope, element) {
                // Compile the contents
                if (!compiledContents) {
                    compiledContents = compile(<JQuery<HTMLElement>><any>contents);
                }
                // Re-add the compiled contents to the element
                compiledContents(scope, function (clone) {
                    element.append(clone);
                });

                // Call the post-linking function, if any
                if (linkFunc && linkFunc.post) {
                    linkFunc.post.apply(null, arguments);
                }
            }
        };
    }
}
